import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  const headlineText = t('hero.headline');

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20professional%20corporate%20business%20scene%20with%20warm%20lighting%2C%20a%20modern%20office%20environment%20featuring%20a%20team%20of%20diverse%20Japanese%20business%20professionals%20in%20formal%20attire%20having%20a%20friendly%20collaborative%20discussion%20at%20a%20bright%20minimalist%20meeting%20room%2C%20warm%20golden%20hour%20sunlight%20streaming%20through%20large%20windows%2C%20clean%20white%20and%20light%20wood%20interior%2C%20soft%20bokeh%20background%2C%20high-end%20corporate%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20conveying%20trust%20professionalism%20and%20human%20connection%2C%20warm%20color%20tones%20with%20navy%20blue%20accents%20in%20the%20environment&width=1600&height=900&seq=hero1&orientation=landscape"
          alt="ビジネスシーン"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-10 xl:px-16 py-20 pt-28 md:pt-32 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight whitespace-pre-line font-jp">
          {headlineText}
        </h1>
        <p className="mt-6 md:mt-8 text-base md:text-lg text-white/90 max-w-3xl mx-auto leading-relaxed font-jp">
          {t('hero.subheadline')}
        </p>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-6 border-b-2 border-r-2 border-white/60 rotate-45" />
      </div>
    </section>
  );
}